import { useEffect, useState } from 'react';
import { PreviewOption } from '@/app/components/shared/viewer/PreviewHeader';

export const usePreviewTabs = (modelUrl?: string) => {
  const [tab, setTab] = useState<PreviewOption>(() =>
    modelUrl ? '3d' : 'gallery'
  );

  useEffect(() => {
    setTab(modelUrl ? '3d' : 'gallery');
  }, [modelUrl]);

  return { tab, setTab };
};
